import { useEffect, useState } from "react";
import { safeNext } from "../lib/safeNext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let enabledOnce = null;
const googleEnabled = () => (enabledOnce ||= axios.get(`${API}/auth/google/config`).then(r => !!r.data.enabled).catch(() => false));

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleSignIn = async (next = "") => {
  const redirectUri = window.location.origin + "/auth/google";
  const safeNextPath = safeNext(next);
  const { data } = await axios.post(`${API}/auth/google/start`, { redirect_uri: redirectUri, next: safeNextPath });
  sessionStorage.setItem("af_google_state", data.state);
  window.location.assign(data.url);
};

export default function GoogleButton({ next = "", testid = "google-signin-btn", label = "Continue with Google" }) {
  const [on, setOn] = useState(false); const [busy, setBusy] = useState(false); const [err, setErr] = useState(null);
  useEffect(() => { let live = true; googleEnabled().then(v => live && setOn(v)); return () => { live = false; }; }, []);
  if (!on) return null;
  const go = async () => {
    setBusy(true); setErr(null);
    try { await startGoogleSignIn(next); } catch (e) { setErr(e?.response?.data?.detail?.message || "Google sign-in couldn't start. Please try again or use your email and password."); setBusy(false); }
  };
  return (
    <div>
      <button type="button" onClick={go} disabled={busy} data-testid={testid}
        className="w-full py-3.5 border inline-flex items-center justify-center gap-3 text-sm bg-white hover:bg-[#f9f9f8] transition-colors disabled:opacity-60"
        style={{ borderColor: 'rgba(15,29,47,0.25)', color: '#0f1d2f' }}>
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
        {busy ? "Opening Google…" : label}
      </button>
      {err && <p className="text-xs mt-2" style={{ color: '#8a2c22' }} role="alert" data-testid={`${testid}-error`}>{err}</p>}
    </div>
  );
}

export const useGoogleEnabled = () => {
  const [on, setOn] = useState(false);
  useEffect(() => { let live = true; googleEnabled().then(v => live && setOn(v)); return () => { live = false; }; }, []);
  return on;
};
